'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _class2, _temp2, _class3, _temp3; /**
                                                      * Created by lyj on 2016/8/12.
                                                      */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {Link} from 'react-router';

var LeftNavButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LeftNavButton, _Component);

  function LeftNavButton() {
    (0, _classCallCheck3.default)(this, LeftNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LeftNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(LeftNavButton, [{
    key: 'render',

    // first: PropTypes.bool
    value: function render() {
      var styles = require('./CarouselTextOfDetail.scss');
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.flexPrev }));
    }
  }]);
  return LeftNavButton;
}(_react.Component), _class.propTypes = {}, _temp);
var RightNavButton = (_temp2 = _class2 = function (_Component2) {
  (0, _inherits3.default)(RightNavButton, _Component2);

  function RightNavButton() {
    (0, _classCallCheck3.default)(this, RightNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(RightNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(RightNavButton, [{
    key: 'render',
    value: function render() {
      var styles = require('./CarouselTextOfDetail.scss');
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.flexNext }));
    }
  }]);
  return RightNavButton;
}(_react.Component), _class2.propTypes = {
  first: _react.PropTypes.bool
}, _temp2);
var CarouselTextOfDetail = (_temp3 = _class3 = function (_Component3) {
  (0, _inherits3.default)(CarouselTextOfDetail, _Component3);

  function CarouselTextOfDetail() {
    (0, _classCallCheck3.default)(this, CarouselTextOfDetail);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(CarouselTextOfDetail).apply(this, arguments));
  }

  (0, _createClass3.default)(CarouselTextOfDetail, [{
    key: 'render',
    value: function render() {
      var styles = require('./CarouselTextOfDetail.scss');
      var _props = this.props;
      var data = _props.data;
      var page = _props.page;
      var onBtnClick = _props.onBtnClick;

      var content = '';
      if (data instanceof Array) {
        var settings = {
          dots: true,
          infinite: true,
          arrows: true,
          dotsClass: 'slick-dots ' + styles.dotsClass,
          fade: false, // fade 设置为 false
          speed: 1500,
          autoplay: false,
          // autoplaySpeed: 5000,
          slidesToShow: 1,
          slidesToScroll: 1,
          pauseOnHover: true,
          prevArrow: data.length > 1 ? _react2.default.createElement(LeftNavButton, this.props) : '',
          nextArrow: data.length > 1 ? _react2.default.createElement(RightNavButton, this.props) : ''
        };
        if (page === 'serviceDetail') {
          content = _react2.default.createElement(
            _reactSlick2.default,
            (0, _extends3.default)({ className: styles.carousel }, settings),
            data.map(function (info, index) {
              return _react2.default.createElement(
                'div',
                { key: index },
                _react2.default.createElement(
                  'div',
                  { className: styles.carouselItem },
                  _react2.default.createElement(
                    'div',
                    { className: styles.title },
                    info.title
                  ),
                  _react2.default.createElement('div', { className: 'clear' }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.price },
                    '价格：¥',
                    info.price
                  ),
                  _react2.default.createElement('div', { className: 'clear' }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.content },
                    info.content
                  ),
                  _react2.default.createElement('div', { className: styles.btn, onClick: function onClick() {
                      return onBtnClick(info.id);
                    } })
                )
              );
            })
          );
        } else {
          content = _react2.default.createElement(
            _reactSlick2.default,
            (0, _extends3.default)({ className: styles.carousel }, settings),
            data.map(function (info, index) {
              return _react2.default.createElement(
                'div',
                { key: index },
                _react2.default.createElement(
                  'div',
                  { className: styles.carouselItem },
                  _react2.default.createElement(
                    'div',
                    { className: styles.title },
                    info.title
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.content },
                    info.content
                  )
                )
              );
            })
          );
        }
      }

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/backgroundwhite.jpg',
          style: { width: '100%', height: '100%' } }),
        content
      );
    }
  }]);
  return CarouselTextOfDetail;
}(_react.Component), _class3.propTypes = {
  // backgroundData: PropTypes.array,
  data: _react.PropTypes.array,
  page: _react.PropTypes.string,
  onBtnClick: _react.PropTypes.func
}, _temp3);
// style={{backgroundImage: 'url(' + backgroundData[0].img + ')'}}

exports.default = CarouselTextOfDetail;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarouselTextOfDetail/CarouselTextOfDetail.js
 ** module id = 1318
 ** module chunks = 0
 **/